import { useState } from 'react';
import { TutorAvatarFallback } from './TutorAvatarFallback';
import './TutorAvatar.css';

export const DEFAULT_TUTOR_NAME = 'Tuan Tuan';
export type TutorExpression =
  | 'friendly'
  | 'greeting'
  | 'listening'
  | 'thinking'
  | 'explaining'
  | 'reassuring';

interface Props {
  size?: 'small' | 'medium' | 'large';
  expression?: TutorExpression;
  animated?: boolean;
}

const sizes = {
  small: { className: 'h-8 w-8', pixels: 32 },
  medium: { className: 'h-12 w-12', pixels: 48 },
  large: { className: 'h-20 w-20', pixels: 80 },
};
const ASSET_ROOT = '/media/tutor/tuantuan-v1';

/** Shared plush Tuan Tuan head; surrounding copy identifies the AI Tutor. */
export function TutorAvatar({ size = 'small', expression = 'friendly', animated = true }: Props) {
  const [failedExpression, setFailedExpression] = useState<TutorExpression | null>(null);
  const { className, pixels } = sizes[size];

  return (
    <span
      aria-hidden="true"
      data-testid="default-tutor-avatar"
      data-character="tuan-tuan"
      data-expression={expression}
      data-animated={animated}
      data-artwork="plush-v1"
      className={`tutor-avatar inline-flex shrink-0 items-center justify-center ${className}`}
    >
      {failedExpression === expression ? (
        <TutorAvatarFallback expression={expression} />
      ) : (
        <img
          key={expression}
          src={`${ASSET_ROOT}/${expression}-${size === 'large' ? 256 : 96}.webp`}
          srcSet={`${ASSET_ROOT}/${expression}-96.webp 96w, ${ASSET_ROOT}/${expression}-256.webp 256w`}
          sizes={`${pixels}px`}
          width={pixels}
          height={pixels}
          alt=""
          draggable={false}
          decoding="async"
          onError={() => setFailedExpression(expression)}
          className="tutor-face tutor-head pointer-events-none select-none object-contain"
        />
      )}
    </span>
  );
}
